import React, { Component } from 'react';
import styled from 'styled-components';

import mediaWidth from '../../utils/mediaWidth/mediaWidth';
import Color from '../../utils/colors';
import { Font, FontWeight } from '../../utils/fonts';

import Content from '../../common/Content';
import Layout from '../../components/Layout';

import ball from './assets/ball.svg';

class NotFoundPage extends Component {
    render() {
        const { className } = this.props;

        return (
            <Root className={className}>
                <Wrapper backgroundColor="#F5F5F5">
                    <ErrorNumberMobile>
                        404
                    </ErrorNumberMobile>
                    <ErrorNumber>
                        <Num>
                            4
                        </Num>
                        <Ball>
                            <Image src={ball} />
                        </Ball>
                        <Num>
                            4
                        </Num>
                    </ErrorNumber>
                    <Message>
                        Такой страницы не существует.
                        <br />
                        Измените запрос или вернитесь
                        <Br360 />
                        {' '}
                        на главную
                    </Message>
                    <LinkTo href="/">
                        На главную
                    </LinkTo>
                </Wrapper>
            </Root>
        );
    }
}

const Root = styled(Layout)`
    ${mediaWidth.xl} {
            background: #F5F5F5;
        }
`;

const Wrapper = styled(Content)`
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    ${mediaWidth.m} {
        background: #F5F5F5;
    }
`;

const ErrorNumberMobile = styled.div`
    ${Font.HEADLINE};
    ${FontWeight.REGULAR};
    font-size: 112px;
    line-height: 130px;

    color: ${Color.TEXT_PRIMARY};

    margin-bottom: 24px;

    ${mediaWidth.l} {
        display: none;
    }
`;

const ErrorNumber = styled.div`
    display: none;

    ${mediaWidth.l} {
        display: flex;
        justify-content: center;
        align-items: center;

        margin-bottom: 24px;
    }

    ${mediaWidth.xl} {
        margin-bottom: 32px;
    }
`;

const Ball = styled.div`
    width: 104px;
    height: 174px;

    ${mediaWidth.xl} {
        width: 132px;
        height: 232px;
    }
`;

const Image = styled.img`
    width: 100%;
    height: 100%;
`;

const Num = styled.div`
    ${Font.HEADLINE};
    ${FontWeight.REGULAR};
    font-size: 150px;
    line-height: 174px;

    color: ${Color.TEXT_PRIMARY};

    ${mediaWidth.l} {
        font-size: 150px;
        line-height: 174px;
    }

    ${mediaWidth.xl} {
        font-size: 200px;
        line-height: 232px;
    }
`;

const Message = styled.div`
    ${Font.PRIMARY};
    ${FontWeight.REGULAR};
    font-size: 16px;
    line-height: 24px;
    text-align: center;

    color: rgba(0, 0, 0, .64);

    margin-bottom: 40px;

    ${mediaWidth.m} {
        font-size: 20px;
        line-height: 28px;

        margin-bottom: 48px;
    }

    ${mediaWidth.xl} {
        font-size: 24px;
        line-height: 32px;

        margin-bottom: 56px;
    }
`;

const LinkTo = styled.a`
    width: 328px;
    height: 63px;

    display: flex;
    justify-content: center;
    align-items: center;

    ${Font.HEADLINE};
    ${FontWeight.REGULAR};
    text-decoration: none;
    text-transform: uppercase;
    font-size: 16px;
    line-height: 19px;

    background: #000000;
    color: #FFFFFF;
    :hover {
        background: #0032A0;
    }
    :active {
        background: #002679;
    }

    ${mediaWidth.m} {
        width: 359px;
        height: 71px;
    }

    ${mediaWidth.xl} {
        width: 406px;
        height: 71px;
    }
`;

const Br360 = styled.br`
    ${mediaWidth.m} {
        display: none;
    }
`;

export default NotFoundPage;
